<template>
  <Intro />
  <CorporatePackages />
  <ServicesDesc />
  <ContactUs />
</template>

<script setup lang="ts">
import Intro from "@/components/services/ServicesIntro.vue";
import CorporatePackages from "@/components/services/CorporatePackages.vue";
import ServicesDesc from "@/components/services/ServicesDesc.vue";
import ContactUs from "@/components/shared/footer/ContactUs.vue";

import { computed, onMounted, ref, toRefs } from "vue";

onMounted(async () => {
  //debugger;
  // window.scrollTo(0, 0);
});
</script>

